// extracted by mini-css-extract-plugin
export var bounce = "_lf-1";
export var generatingText = "_lf-6";
export var lightning = "_lf-4";
export var popup = "_lf-5";
export var progressBar = "_lf-7";
export var progressFill = "_lf-8";
export var progressShimmer = "_lf-9";
export var progressText = "_lf-a";
export var shimmer = "_lf-3";
export var uploadIcon = "_lf-0";
export var uploadingText = "_lf-2";